import selectMember from '@/common/select-user/select-user.vue'
import selectUserCmp from '@/common/select-user-cmp/index.vue'
import ProcessMonitor from '@/common/wf/v2/process-monitor.vue'
import CopyForm from '@/common/wf/copy-form/index.vue'
import Upload from '@/common/upload/upload.vue'
import {getMyCommentData, deleteData} from '../../../api/workflow'

import {wfUtil} from './process-form'

function getConditionValue(condition, operate)
{
  // alert(condition+"---"+operate);
  var name = condition.substring(0, condition.indexOf(operate)).trim();
  var value = condition.substring(condition.indexOf(operate) + operate.length).trim();
  // alert(name+"***"+value);
  var obj =
    {
      name : name,
      value : value

    };
  return obj;
}

export const mixin = {
  name: 'ProcessForm',
  props: {
    model: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readOnly: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      transferCopy: false, // 转阅，创建人和管理员有权限转阅
      transferCopyVisible:false,
      rollbackDataBtnVisible: false, // 反核销按钮
      defaultConfig: {
        ifHasProcess: true // 是否该表单拥有流程
      },
      commentOptions: [], // 常用审批意见
      commentSelectValue: '', // 常用审批意见下拉框绑定
      pngSrc: null,
      imageWidth: '200px',
      srcList:[],
      pngTitle: '流程图',
      pngVisible: false,
      procTaskVisible: false, // 显示流转记录
      showProcUserDelete: false, // 显示处理人的删除按钮
      showCopyUserDelete: false, // 显示抄送人的删除按钮
      // showSelectProcUser: false,//显示选择处理人
      // showSelectCopyUser: false,//显示选择抄送人
      showProcessMonitor: false, // 显示流程监控
      dialogSelProcVisible: false, // 是否显示流程选择框
      processMonitorCount: 0,
      processMonitorVisible: false, // 流转记录弹框
      processMonitorModel: {
        // 流程监控
      },
      procUserModel: {
        //
        isShow: false,
        selectList: [],
        callBack: this.selectProcUserCallback,
        radioSelectFlags: false
      },
      copyUserModel: {
        // 抄送模型
        isShow: false,
        selectList: [],
        callBack: this.selectCopyUserCallback,
        radioSelectFlags: false
      },
      uploadConfig: {
        autoLoad: false,
        visible: false,
        autoLoad: false
      }, // 附件配置
      id: '', // 业务主键
      comment: '', // 审批意见
      processList: [], // 流程列表
      modelList: [], // 流程模型
      ifShowProc: false, // 是否显示处理人
      ifShowCopy: false, // 是否显示抄送
      ifSelUser: false, // 是否允许选人
      isNewFlag: true, // 是否新增业务数据
      isReadOnly: true, // 是否只读
      ifSelCopy: false, // 是否允许选择抄送
      ifToOther: false, // 转他人
      isRevocation: false, // 是否撤回
      delegateTask: false, // 是否当前任务是委派任务
      procDefId: '', // 流程定义主键
      procDefName: '', // 流程定义
      procInstId: '', // 流程实例主键
      taskId: '', // 任务主键
      isWorkflow: false, // 是否可以处理流程
      isApply: false, // 是否是我申请的
      isCopy: false, // 是否处理抄送
      ifBackFirst: false, // 是否回退首环节
      ifFirstNode:false, // 是否首环节
      isApproval: false, // 是否处理待办
      activitiData: [], // 处理待办时后置节点信息
      currentActId: null, // 处理待办时当前环节
      taskStatus: null, // 任务状态claim/toDo
      taskType: null, // 任务类型，1表示抄送，0表示待办
      selectedAct: null, // 选中的后置环节
      assingeeDialogTitle: '', // 转他人或者委托人
      assingeeDialogVisible: false,
      assigneeOperateType: null,
      mainFormData: {} // 主表数据
      // readOnly: true // 设置是否只读
    }
  },
  components: {
    ProcessMonitor,
    selectMember,
    Upload,
    CopyForm,
    selectUserCmp
  },
  created () {
    this.util.init(this)
    wfUtil.init(this)
    // console.info("processForm=======created========");
    // this.config =  this.defaultConfig;
  },
  activated () {
    // console.info("processForm=======activated========");
  },
  mounted () {
    this.delegateTask = false
    this.transferCopy = false;
    this.transferCopyVisible = false;
    this.rollbackDataBtnVisible = false
    this.procTaskVisible = false
    this.procDefId = null
    this.procInstId = null
    this.taskId = null
    this.taskStatus = null
    this.currentActId = null
    this.taskType = null
    this.isWorkflow = false
    this.isReadOnly = true
    this.ifBackFirst = false
    this.isEndEvent = false
    this.isApply = false
    this.isApproval = false
    this.isEndEvent = true
    this.isCopy = false
    this.ifShowProc = false
    this.ifToOther = true ;
    this.isRevocation= false;
    this.processMonitorCount = 0
    this.showProcessMonitor = false
    this.processMonitorModel.parent = this
    this.assingeeDialogVisible = false
    this.activitiData = []
    this.mainFormData = null
    this.uploadConfig = {
      autoLoad: false,
      visible: false
    }
    // console.info("processForm=======mounted========");
    if (this.model.ifHasProcess != undefined && !this.model.ifHasProcess) {
      this.defaultConfig.ifHasProcess = false
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_procInstId'))) {
      this.procInstId = this.util.getUrlParam('_procInstId')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_procDefId'))) {
      this.procDefId = this.util.getUrlParam('_procDefId')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_taskId'))) {
      this.taskId = this.util.getUrlParam('_taskId')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_taskType'))) {
      this.taskType = this.util.getUrlParam('_taskType')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_currentActId'))) {
      this.currentActId = this.util.getUrlParam('_currentActId')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('_taskStatus'))) {
      this.taskStatus = this.util.getUrlParam('_taskStatus')
    }
    if (this.validUtil.isNotEmpty(this.util.getUrlParam('id'))) {
      this.id = this.util.getUrlParam('id')
    }
    // console.info('this.procInstId-------'+this.procInstId)
    // this.initProcess()
  },
  methods: {
    initProcess () {
      this.isNewFlag = false;
      var _this = this
      // console.info('-----initProcess-----',this.model,this.model.parent)
      if (this.model.parent) {
        this.isNewFlag = this.model.parent.isNewFlag;
        this.model.parent.processForm = this
        // 判断是否表单已经设置只读
        if (this.readOnly) {
          _this.isReadOnly = true
        }
        // 判断如果弹框打开this.id无法从url读取
        if(this.validUtil.isNull(this.id)){
          if(this.validUtil.isNotNull(this.model.parent.businessKey)){
            this.id = this.model.parent.businessKey
          }
        }
        // console.info('--------------'+_this.isReadOnly)
      }
      // console.info("processForm=======initProcess========" + this.defaultConfig.ifHasProcess);
      if (this.defaultConfig.ifHasProcess) {
        // console.info("-------" + this.taskId);
        // 说明是待办、待阅、已办、已阅
        if (this.validUtil.isNotEmpty(this.taskId)) {
          // 待办
          if (
            _this.validUtil.isNotEmpty(this.taskType) &&
            this.taskType != '1'
          ) {
            _this.loadExecution()
          } else if (
            _this.validUtil.isNotEmpty(this.taskType) &&
            this.taskType == '1'
          ) {
            this.updateReadOnly(true)
            // 抄送
            _this.loadExecution()
            _this.isReadOnly = true
          }
        } else if (this.validUtil.isNotEmpty(this.procInstId)) {
          // 说明是我申请的
          // _this.loadExecution();
          // this.util.post("/workflow/openWorkflow", {procDefId:this.procDefId,procInstId:this.procInstId}, function (res) {
          //     if (res != undefined && res.status == 200) {
          //     }
          // });
          // console.info('---------我申请的--------')
          this.updateReadOnly(true)
          _this.loadExecution()
        } else {
          // console.info('=================')
          // 说明是第一次提交
          let params = {
            formKey: this.model.formKey,
            sqlTableName: this.model.parent.tableName,
            businessKey: this.model.businessKey,
            currentUserUid: this.sessionUtil.getUserUid()
          }
          // 传递主表数据到后台
          if (this.model.parent.getData != undefined) {
            var data = this.model.parent.getData()
            params['mainFormDataMap'] = data['mainFormDataMap']
            this.mainFormData = data['mainFormDataMap']
            if (this.validUtil.isNull(params.id)) {
              params['id'] = data['businessKey']
              params['businessKey'] = data['businessKey']
            }
          }

          this.util.restPost('/api_v1/wf/process', params, function (res) {
            // console.info(res);
            // 判断是否流程结束,1.有流程结束时间；2.没有结束时间，但是状态-5
            if (res.data && (_this.validUtil.isNotNull(res.data.endTime || (_this.validUtil.isNull(res.data.endTime) && res.data.procStatus && res.data.procStatus === -5)))) {
              // 显示反核销按钮
              if (_this.sessionUtil.isCompanyAdmin()) {
                _this.rollbackDataBtnVisible = true

              }
              // console.log('-------transferCopy---------'+_this.sessionUtil.isAllowWfFinishedCopy());
              // 判断是否允许转阅
              if(_this.sessionUtil.isAllowWfFinishedCopy()){
                _this.transferCopy  = true
              }
            }
            // 根据配置的启动规则计算流程
            wfUtil.initModel(res)
            // console.info('isWorkflow=='+_this.isWorkflow)
          }
          )
        }
        // console.info("======");
      } else {
        // 说明不是流程
        this.isWorkflow = false
      }
    },
    trim(result){
      result = result.replace(/(^\s+)|(\s+$)/g, "");
      result = result.replace(/\s/g, "");
      return result;
    },
    computeCondition(activitiesData){ // 计算分支节点
      let mainFormData = {...this.mainFormData}
      // 增加session数据
      // extend(mainFormData, sessionData);

      // console.log('----computeCondition-----',activitiesData,mainFormData)

      for (var i = 0; i < activitiesData.length; i++)
      {
        let node = activitiesData[i]
        node.visible = true
        // console.info(node);
        var condition = node.condition;
        if (condition != null && condition != undefined && condition != "")
        {
          var flag;
          condition = this.trim(condition);
          // var str = "1 ${ aa == 1 } 2";
          // str = str.trim();
          // alert(str);
          condition = condition.substring(2, condition.length - 1);
          // alert(condition);
          // 多条件
          if (condition.indexOf("||") > -1 || condition.indexOf("&&") > -1)
          {
            var index = -1;
            for (var key in mainFormData)
            {
              // condition = condition.replaceAll(key,mainFormData[key]);
              //alert(key);
              if (condition.indexOf(key) > -1)
              {
                // alert("ok"+condition.indexOf(key+"=="));
                index = -1;
                if (condition.indexOf(key + "==") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                else if (condition.indexOf(key + "!=") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                else if (condition.indexOf(key + ">=") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                else if (condition.indexOf(key + "<=") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                else if (condition.indexOf(key + ">") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                else if (condition.indexOf(key + "<") > -1)
                {
                  index = condition.indexOf(key) + key.length + 2;
                }
                if (condition.charAt(index) == "\"")
                {
                  condition = condition.replaceAll(key, "\"" + mainFormData[key] + "\"");
                }
                else
                {
                  condition = condition.replaceAll(key, mainFormData[key]);
                }
              }
            }

            condition = "flag = (" + condition + ")";
            //alert(condition);
          }
          else
          {

            var con;
            if (condition.indexOf("==") > -1)
            {
              con = getConditionValue(condition, "==");
              con.operate = "==";
            }
            else if (condition.indexOf(">=") > -1)
            {
              con = getConditionValue(condition, ">=");
              con.operate = ">=";
            }
            else if (condition.indexOf("<=") > -1)
            {
              con = getConditionValue(condition, "<=");
              con.operate = "<=";
            }
            else if (condition.indexOf(">") > -1)
            {
              con = getConditionValue(condition, ">");
              con.operate = ">";
            }
            else if (condition.indexOf("<") > -1)
            {
              con = getConditionValue(condition, "<");
              con.operate = "<";
            }
            else if (condition.indexOf("!=") > -1)
            {
              con = getConditionValue(condition, "!=");
              con.operate = "!=";
            }
            var value = "";

            //console.info(sessionData);
            value = mainFormData[con.name];
            if (typeof value == "undefined" || value == null || value == "")
            {
              continue;
            }
            // if(!Ext.isNumeric(value)){
            if (con.value.indexOf("\"") > -1)
            {
              condition = "flag = (\"" + value + "\"" + con.operate + con.value + ")";
            }
            else
            {
              condition = "flag = (" + value + con.operate + con.value + ")";
            }

          }
          //alert(condition);
          eval(condition);
          console.log(node.name+'： '+flag,condition)
          if (flag == false)
          {
            // alert(activitiesData[i].id);
             node.visible = false

          }
          else
          {
            node.visible = true
          }
        }

      }
      // debugger
    },
    renderApprovalForm (data) {
      let _this = this
      // 待办
      _this.ifSelCopy = data['ifSelCopy']
      _this.isWorkflow = true
      _this.ifShowCopy = true
      _this.isReadOnly = false
      _this.isApply = false
      _this.isEndEvent = false
      // console.log('------data.delegateTask-------',data.delegateTask)
      if(data.delegateTask !== undefined && data.delegateTask) {
        _this.delegateTask = true
      }
      // 如果是第一环节说明是驳回
      if (data.ifFirstNode && data.activities && data.activities.length > 0) {
        // 如果是驳回则可以继续编辑数据,
        if (_this.validUtil.isNotNull(data.procInstId)) {
          _this.ifBackFirst = true
        }
        // 判断如果草稿状态时保存了申请说明，则这里直接渲染
        if(_this.validUtil.isNotNull(data.comment)){
          _this.comment = data.comment;
        }
        // 如果taskId存在则说明是从申请列表进入，或者直接从单据进入，taskId是后台返回
        if (_this.validUtil.isNull(_this.taskId) && _this.validUtil.isNotNull(data.taskId)) {
          _this.taskId = data.taskId
          _this.procInstId = data.procInstId
          _this.procDefId = data.procDefId
        }
        _this.updateReadOnly(false)
      } else {
        if (_this.validUtil.isNotEmpty(_this.procInstId)) {
          _this.isApproval = true
          _this.updateReadOnly(true)
        } else {
          // 第一次提交
        }
      }

      // 自动计算分支
      this.computeCondition(data.activities)
      let find = -1
      // 重新排序，如果结束在之前的话
      let newData = data.activities;
      let visible = false;
      for (var i = 0; i < data.activities.length; i++) {
        var item = data.activities[i];
        if(item.visible){
          visible = true;
        }
      }

      for (var i = 0; i < newData.length; i++) {
        var item = newData[i]
        item.showProcUserDelete = false
        // console.log(item.name+'------'+item.visible)
        // 默认第一个选中
        if(item.visible){
          // 包容分支
          if(item.selectType === 'checkbox'){
            item.selected = false
            this.ifShowProc = true
          }else if(item.selectType === 'disabled'){
            // 并行分支
            item.selected = true
            this.ifShowProc = true
          }else{
            // 排他分支
            if (find == -1) {
              item.selected = true
              _this.initProcUsers(item)
              find = i
            } else {
              item.selected = false
            }
          }

        }else{
          item.selected = false
        }

      }
      _this.activitiData = newData
      _this.initCopyUsers(data)
      // 隐藏父页面的流程监控
      if (_this.model.parent && _this.model.parent.hideProcessMonitor) {
        _this.model.parent.hideProcessMonitor()
      }
    },
    loadExecution () {
      // 加载流程处理单
      var _this = this

      let params = {
        id: this.id,
        key: this.key,
        formKey: this.model.formKey,
        procInstId: this.procInstId,
        taskId: this.taskId,
        taskType: this.taskType,
        procDefId: this.procDefId,
        currentUserUid: this.sessionUtil.getUserUid()
      }

      if(this.model.parent){
        params['sqlTableName'] = this.model.parent.tableName
      }

      let projUid = this.sessionUtil.getProjUid(this)
      if(this.validUtil.isNotNull(projUid)){
        params.projectId = projUid
      }
      if (this.model.parent.mask != undefined) {
        this.model.parent.mask()
      }
      // 传递主表数据到后台
      if (this.model.parent.getData != undefined) {
        var data = this.model.parent.getData()
        params['mainFormDataMap'] = data['mainFormDataMap']
        this.mainFormData =  data['mainFormDataMap']
        if (this.validUtil.isNull(params.id)) {
          params['id'] = data['businessKey']
          params['businessKey'] = data['businessKey']
        }
      }
      // console.log('--------loadExecution--------', this.model.parent)
      if (this.model.parent.getFileColumns != undefined) {
        var fileColumns = this.model.parent.getFileColumns()
        if (fileColumns && fileColumns.length > 0) {
          // 附件配置, 默认主表第一个附件配置
          this.uploadConfig = {
            autoLoad: false,
            visible: true,
            xtype: fileColumns[0].columnName || ''
          }
        }
        // console.log('-----this.uploadConfig-------', fileColumns, this.uploadConfig)
      }

      this.util.restPost(
        '/api_v1/wf/execution',
        params,
        function (res) {
          if (res.status == 200) {
            // 判断是否流程结束
            if (res.data && _this.validUtil.isNotNull(res.data.endTime) && _this.validUtil.isNull(res.data.taskId)) {
              // 显示反核销按钮
              if (_this.sessionUtil.isCompanyAdmin()) {
                _this.rollbackDataBtnVisible = true
              }

            }
            if (res.data && _this.validUtil.isNotNull(res.data.endTime)){
              // 判断是否允许转阅
              if(_this.sessionUtil.isAllowWfFinishedCopy()){
                _this.transferCopy  = true
              }
            }
            if (res.data && _this.validUtil.isNotNull(res.data.formAuth)) {
              // 修改流程权限
              if (_this.model.parent && _this.model.parent.updateWfFormAuth) {
                _this.model.parent.updateWfFormAuth(res.data.formAuth)
              }
            }
            // 可以处理
            if (res.data.enable == undefined || res.data.enable == 1) {
              _this.ifFirstNode = res.data.ifFirstNode
              // 如果是待阅
              if (
                _this.validUtil.isNotEmpty(_this.taskId) &&
                _this.taskType == '1'
              ) {
                _this.isWorkflow = true
                _this.isCopy = true
                _this.initProcessMonitor()
                // 隐藏父页面的流程监控
                if (_this.model.parent && _this.model.parent.hideProcessMonitor) {
                  _this.model.parent.hideProcessMonitor()
                }
                if (_this.model.parent.unmask != undefined) {
                  _this.model.parent.unmask()
                }
                return
              } else if (
                (_this.validUtil.isNotEmpty(_this.taskId) &&
                  _this.taskType == '0') ||
                (res.data['activities'] != undefined &&
                  res.data['activities'].length > 0)
              ) {
                _this.renderApprovalForm(res.data)
              } else {
                // 我申请的
                _this.isWorkflow = true
                _this.isApply = true
              }
            } else {
              //console.log('---------------------------');
              // 判断是否撤回
              if(res.data['operateType'] && res.data['operateType']==12){
                // 在index.html中开启关闭，默认是关闭
                if(window.wf_btn_revocation){
                  _this.isRevocation= true;
                  _this.isWorkflow = true;
                }

              }
              // console.log('--------111-------')
              // 说明当前打开表单的不是处理人本人，或者该任务不存在
              // 隐藏父页面的流程监控
              /* if(_this.model.parent && _this.model.parent.hideProcessMonitor){
                _this.model.parent.hideProcessMonitor()
              } */
            }
            _this.initProcessMonitor()
          } else {
            _this.util.error(res['errorMsg'])
          }
          if (_this.model.parent.unmask != undefined) {
            _this.model.parent.unmask()
          }
        }
      )
      this.commentOptions = []
      // 加载我的审批记录
      getMyCommentData().then(res => {
        // console.log('--------getMyCommentData---------', res)
        let commentOptions = [{
          name: '--请选择--',
          value: ''
        }]
        if (res.data && res.data.length > 0) {
          res.data.forEach(item => {
            commentOptions.push({
              name: item['TITLE_'],
              value: item['CONTENT_']
            })
          })
        }
        this.commentOptions = commentOptions
      })
    },
    handlerCommentSelect (newVal) { // 选择常用审批意见
      console.log('--------handlerCommentSelect---------', newVal)
      this.comment = newVal
    },
    handlerOpenCommentConfig () { // 打开常用意见审批配置
      console.log('--------handlerOpenCommentConfig---------')
      this.$router.push({
        name: 'form-query',
        params: {
          formKey: 'sys-wf-comment',
          title: '我的常用审批意见'
        }
      })
    },
    updateReadOnly (readOnly) { // 修改表单只读状态
      if (this.model.parent && this.model.parent.updateReadOnly) {
        this.model.parent.updateReadOnly(readOnly)
      }
    },
    initProcUsers (item) {
      // 初始化环节处理人
      if (item.type != 'endType' && item.taskType != 'endEvent') {
        this.ifShowProc = true
      } else {
        this.ifShowProc = false
      }
      var procUsers = item.procUsers
      this.selectedAct = item
      var selectList = []
      if (procUsers != undefined && procUsers.length > 0) {
        for (var i = 0; i < procUsers.length; i++) {
          var procUser = procUsers[i]
          selectList.push({
            id: procUser.procUserUid,
            userName: procUser.procUserName,
            userId: procUser.procUserId,
            picture: procUser.picture
          })
        }
      }
      this.procUserModel.selectList = selectList

      if (item.ifSelUser) {
        this.ifSelUser = true
      } else {
        this.ifSelUser = false
      }
      // console.info('----------this.selectedAct----------')
      // console.info(this.selectedAct)
      // this.procUserModel.isShow = true;
    },
    initCopyUsers (item) {
      // 初始化环节抄送人
      var copyUsers = item.copyUsers
      // this.selectedAct = item;
      var selectList = []
      if (copyUsers != undefined && copyUsers.length > 0) {
        for (var i = 0; i < copyUsers.length; i++) {
          var procUser = copyUsers[i]
          selectList.push({
            id: procUser.procUserUid,
            userName: procUser.procUserName,
            userId: procUser.procUserId,
            picture: procUser.picture
          })
        }
      }
      this.copyUserModel.selectList = selectList

      if (item.ifSelCopy) {
        this.ifSelCopy = true
      } else {
        this.ifSelCopy = false
      }
    },
    initProcessMonitor () {
      // 加载流程监控
      this.showProcessMonitor = true
      return
      var _this = this
      // console.info(_this.$refs.processMonitor);
      if (this.processMonitorCount > 100) {

      }
      if (_this.$refs.processMonitor == undefined) {
        this.processMonitorCount++
        setTimeout(function () {
          _this.initProcessMonitor()
        }, 500)
      }
      // console.info("=======");
      this.processMonitorCount = 0
      _this.$refs.processMonitor.initProcess(_this.procInstId, _this.procDefId)
    },
    addProcUser (node) {
      // 添加处理人
      this.selectedAct = node
      // console.info(this.$refs.selectProcUser);
      if (node) {
        var procUsers = node.procUsers
        var selectList = []
        if (procUsers != undefined && procUsers.length > 0) {
          for (var i = 0; i < procUsers.length; i++) {
            var procUser = procUsers[i]
            selectList.push({
              id: procUser.procUserUid,
              userName: procUser.procUserName,
              userId: procUser.procUserId,
              picture: procUser.picture
            })
          }
        }
        this.procUserModel.selectList = selectList
      }

      // console.info(this.procUserModel.selectList)
      this.procUserModel.isShow = true
      // this.procUserModel.selectList =
      // this.$refs.selectProcUser.sync(this.procUserModel.selectList);
    },
    removeProcUser (node,user) {
      node.procUsers = node.procUsers.filter(item => {
        return item.procUserUid != user.procUserUid
      })
    },
    delProcUser (item) {
        item.showProcUserDelete = !item.showProcUserDelete
    },
    addCopyUser () {
      // 添加处理人
      console.info(this.$refs.selectCopyUser)
      this.copyUserModel.isShow = true
      // this.$refs.selectCopyUser.sync(this.copyUserModel.selectList);
    },
    removeCopyUser (user) {
      this.copyUserModel.selectList = this.copyUserModel.selectList.filter(
        item => {
          return item != user
        }
      )
    },
    delCopyUser () {
      this.showCopyUserDelete = !this.showCopyUserDelete
    },
    selected (item, list) {
      // 如果是并行则不操作
      if(item.selectType === 'disabled'){
        return
      }
      // console.info("====selected===="+item.id);
      // console.info(item);
      // 由于单选
      for (var i = 0; i < list.length; i++) {
        // 默认第一个选中
        var temp = list[i]
        // console.info(temp.id +'=='+ item.id)
        if (temp.id == item.id) {
          temp.selected = true
        } else {
          temp.selected = false
        }
      }
      // this.processList = list
      // console.info(this.processList)
      // console.info( this.processList);
    },
    selectProcUserCallback () {
      // console.info("====selectProcUserCallback====");
      // console.info(this.procUserModel.selectList);
      var selectList = []
      for (var i = 0; i < this.procUserModel.selectList.length; i++) {
        var procUser = this.procUserModel.selectList[i]
        selectList.push({
          procUserUid: procUser.id,
          procUserName: procUser.userName,
          procUserId: procUser.userId,
          picture: procUser.picture
        })
      }
      this.selectedAct.procUsers = selectList
      this.procUserModel.isShow = false
      // console.info('-------selectProcUserCallback--------')
      // console.info(this.selectedAct)
    },
    selectCopyUserCallback () {
      // console.info("====selectCopyUserCallback====");
      this.copyUserModel.isShow = false
    },
    getData(){
      if(this.model.parent){
        var formData = this.model.parent.getData()
        return formData;
      }
      return null;
    },
    submit (type) {
      let _this = this
      if (type === -2) {
        this.util.confirm('反核销将只删除流程审批数据，确定要反核销吗？', '提示', () => {
          deleteData({businessKey: _this.model.businessKey, sqlTableName: _this.model.parent.tableName}).then(() => {
            _this.util.success('反核销成功！')
            _this.rollbackDataBtnVisible = false
            if (_this.model.parent.saveDataCallback != undefined) {
              _this.model.parent.saveDataCallback(type)
            }
          })
        })
        return
      }
      if (type == 1 || type == 6 || type == 8 || type == 16 || type== 17) {
        // 校验表单
        // 判断父组件是否复写表单验证方法
        if (this.model.parent.checkValid != undefined) {
          this.model.parent.checkValid().then(() => {
            _this.confirmSubmit(type)
          })
        }
      } else if (type == 9 || type == 10) {
        // 删除配置parent 避免JSON.stringify报错
        this.$parent.submit(9)
      } else if(type == 18){
        this.util.confirm('确定要撤回任务吗', '提示', () => {
          this.confirmSubmit(type);
        });
      } else {
        if (type === 5 || type === 11) {
          if(this.validUtil.isNull(this.comment)){
            this.util.warn('请填写审批意见！')
            return
          }
          this.util.confirm(type === 5 ? '确定要返回上一环节' : '确定要返回首环节', '提示', () => {
            this.confirmSubmit(type)
          })
        } else {
          this.confirmSubmit(type)
        }
      }
    },
    confirmSubmit (type) {
      var _this = this
      if (type == 0) {
        if (this.model.parent) {
          this.model.parent.closeProcessForm()
          return
        }
        // 取消
        if (this.model.parent.cancelCallback != undefined) {
          this.model.parent.cancelCallback()
        } else {
          history.back()
        }
        return
      } else if (type == 7) {
        // 当多个流程时弹出流程选择框中的确定
        for (var i = 0; i < this.processList.length; i++) {
          // 默认第一个选中
          var temp = this.processList[i]
          if (temp.selected) {
            this.isWorkflow = true
            this.procDefId = temp.procDefId
            this.procDefName = temp.name
            this.key = temp.key
            this.closeSelDialog()
            // 加载流程处理单
            this.loadExecution()
            return
          }
        }
      } else if (type == 8) {
        // 提交，判断是否流程定义还没有，并且该表单有多个流程,&& this.modelList.length > 1
        if (this.validUtil.isNull(this.procDefId) ) {
          wfUtil.compute()
          return
        }
      } else if (type == 12) {
        // 转让人
        this.assingeeDialogTitle = '转他人处理'
        this.assingeeDialogVisible = true
        this.assigneeOperateType = 12
        return
      } else if (type == 13) {
        // 委托人
        this.assingeeDialogTitle = '委托人处理'
        this.assingeeDialogVisible = true
        this.assigneeOperateType = 13
        return
      }
    console.log('-------confirmSubmit------',type)
      var maskStr = '正在保存...'
      var params = {}
      if (this.isWorkflow) {
        if(this.validUtil.isNull(this.comment)){
          // 如果客户点击同意，且没有录入审批意见，则默认同意
          if(!this.ifBackFirst && type === 6){
            this.comment = '同意'
          }
          if(!this.ifBackFirst && type === 5){
            // this.comment = '不同意'
          }
          if(!this.ifBackFirst && type === 11){
            // this.comment = '驳回'
          }
        }
        params['comment'] = this.comment
        params['procDefName'] = _this.validUtil.isNotEmpty(this.procDefName)
          ? this.procDefName
          : this.model.parent.modelName
        params['procDefId'] = _this.procDefId
        params['taskId'] = _this.taskId
        params['taskType'] = _this.taskType
        params['procInstId'] = _this.procInstId
        params['ifSaveWorkflow'] = true
      }
      // console.log('----this.id----',this.id)
      params['id'] = this.id
      params['businessKey'] = params['id']
      params['currentUserUid'] = this.sessionUtil.getUserUid(this)
      params['currentUserName'] = this.sessionUtil.getUserName(this)
      params['currentUserId'] = this.sessionUtil.getUserId(this)
      params['formKey'] = this.model.parent.formKey || this.model.formKey
      params['sqlTableName'] = this.model.parent.tableName
      params['entityId'] = this.model.parent.entityId
      // 只是点击保存,或者近提交修改状态
      if (type == 1 || type == 16) {
        // //判断父组件是否复写表单验证方法
        // if (this.model.parent.checkValid != undefined) {
        //   if (!this.model.parent.checkValid()) {
        //     return;
        //   }
        // }
        // 判断表单是否复写获取数据的方法
        if (this.model.parent.getData != undefined) {
          var formData = this.model.parent.getData()
          // 合并对象
          params = Object.assign(params, formData)
          params['ifSaveWorkflow'] = false
        }
        if (type === 16) {
          params['operateType'] = 16
        }
      }
      if (type == 6 || type == 8 ) {
        // type == 6表示按钮是同意，8表示提交
        maskStr = '正在提交...'
        // 如果不是抄送则获取表单数据和下一环节数据
        if (this.taskType != '1') {
          if (this.model.parent != undefined) {
            // if (this.model.parent.checkValid != undefined) {
            //   if (!this.model.parent.checkValid()) {
            //     return;
            //   }
            // }
            // console.info("-------"+this.model.parent.getData);
            if (this.model.parent.getData != undefined) {
              var formData = this.model.parent.getData()
              // 合并对象
              params = Object.assign(params, formData)
              params['ifSaveWorkflow'] = true
            }
          }
          // console.info(params)
          // _this.util.successToast("----数据获取完毕-----");
          if (this.model.parent.agentId != undefined) {
            params['agentId'] = this.model.parent.agentId
          }
          if (!_this.isEndEvent && !_this.delegateTask) {
            for (var i = 0; i < _this.activitiData.length; i++) {
              var act = _this.activitiData[i]
              if (act.selected) {
                // console.info(act);
                if (act.type != 'endType' && act.taskType != 'endEvent') {
                  if (act.procUsers.length == 0) {
                    this.util.failueToast('请选择[' + act.name + ']处理人！')
                    return false
                  }
                }
              }
            }
          }

          var newActivitiData = []
          for (var i = 0; i < _this.activitiData.length; i++) {
            var act = _this.activitiData[i]
            if (act.selected) {
              newActivitiData.push(act)
            }
          }
          if(newActivitiData.length == 0){
            this.util.warn("请您选择下一个审批节点");
            return;
          }
          // console.info(this.activitiData);
          // console.info(this.copyUserModel.users);
          // params['activityData'] = JSON.stringify(newActivitiData);
          params['activities'] = newActivitiData
          // console.info(this.copyUserModel.users);
          var copyUsersArr = new Array()
          for (var i = 0; i < this.copyUserModel.selectList.length; i++) {
            var procUser = this.copyUserModel.selectList[i]
            var user = new Object()
            user.id = procUser['id']
            user.userName = procUser['userName']
            user.mobile = procUser['mobile']
            user.wxId = procUser['wxId']
            copyUsersArr.push(user)
          }
          // console.info(this.copyUserModel.users);
          params['copyUsersStr'] = JSON.stringify(copyUsersArr)
          params['operateType'] = 0
        } else {
          // 如果是抄送
          params['operateType'] = 1
        }
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
      } else if (type == 5) {
        // 不同意，回退上一环节
        params['mainFormData'] = null
        params['subFormData'] = null
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 6
      } else if (type == 11) {
        if (this.model.parent.getData != undefined) {
          var data = this.model.parent.getData()
          // console.info(data);
          params['subject'] = data['subject']
          params['abstracts'] = data['abstracts']
        }
        // 驳回，回退首环节
        params['mainFormData'] = null
        params['subFormData'] = null
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 5
      } else if (type == 14) { // 转他人
        if (this.model.parent.getData != undefined) {
          var data = this.model.parent.getData()
          // console.info(data);
          params['subject'] = data['subject']
          params['abstracts'] = data['abstracts']
        }
        // 获取设置的处理人
        let selectedUser = this.$refs['select-user-cmp'].getSelectedData()
        // console.log('-----selectedUser-----',selectedUser)
        if (selectedUser.length == 0) {
          this.util.warn('请设置处理人!')
          this.assingeeDialogVisible = true
          return
        } else {
          params['assignee'] = selectedUser[0].id
          params['assigneeCn'] = selectedUser[0].userName
        }
        // 转他人
        params['mainFormData'] = null
        params['subFormData'] = null
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 2
        // return
      } else if (type == 15) { // 委托人
        if (this.model.parent.getData != undefined) {
          var data = this.model.parent.getData()
          // console.info(data);
          params['subject'] = data['subject']
          params['abstracts'] = data['abstracts']
        }
        // 获取设置的处理人
        let selectedUser = this.$refs['select-user-cmp'].getSelectedData()
        // console.log('-----selectedUser-----',selectedUser)
        if (selectedUser.length == 0) {
          this.util.warn('请设置处理人!')
          return
        } else {
          params['assignee'] = selectedUser[0].id
          params['assigneeCn'] = selectedUser[0].userName
        }
        // 转他人
        params['mainFormData'] = null
        params['subFormData'] = null
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 3
        // return
      }else if (type == 17) {
        // 同意并结束
        maskStr = '正在提交...'

        if (this.model.parent != undefined) {
          if (this.model.parent.getData != undefined) {
            var formData = this.model.parent.getData()
            // 合并对象
            params = Object.assign(params, formData)
            params['ifSaveWorkflow'] = true
          }
        }
        if (this.model.parent.agentId != undefined) {
          params['agentId'] = this.model.parent.agentId
        }

        var copyUsersArr = new Array()
        for (var i = 0; i < this.copyUserModel.selectList.length; i++) {
          var procUser = this.copyUserModel.selectList[i]
          var user = new Object()
          user.id = procUser['id']
          user.userName = procUser['userName']
          user.mobile = procUser['mobile']
          user.wxId = procUser['wxId']
          copyUsersArr.push(user)
        }
        // console.info(this.copyUserModel.users);
        params['copyUsersStr'] = JSON.stringify(copyUsersArr)
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 17
      }else if (type == 18) {
        // 撤回
        params['mainFormData'] = null
        params['subFormData'] = null
        params['sqlTableName'] = this.validUtil.isNotEmpty(this.model.parent.tableName) ? this.model.parent.tableName : this.model.parent.sqlTableName
        params['operateType'] = 12
      } else if (type == 3) {
        // 撤销
        if (this.model.parent.getData != undefined) {
          var data = this.model.parent.getData()
          // console.info(data);
          params['subject'] = data['subject']
          params['abstracts'] = data['abstracts']
        }
        params['procDefName'] = _this.procDefName
        params['formKey'] = this.model.parent.formKey || this.model.formKey
        params['sqlTableName'] = this.model.parent.tableName
        params['procDefId'] = _this.procDefId
        params['id'] = this.id == undefined ? '' : this.id
        params['businessKey'] = params['id']
        params['currentUserUid'] = this.sessionUtil.getUserUid(this)
        params['currentUserName'] = this.sessionUtil.getUserName(this)
        params['currentUserId'] = this.sessionUtil.getUserId(this)
        params['ifSaveWorkflow'] = true
        params['operateType'] = 14
        params['procInstId'] = _this.procInstId
        maskStr = '正在撤销...'
      } else if (type == 4) {
        // 催办
        if (this.isWorkflow) {
          if (this.model.parent.getData != undefined) {
            var data = this.model.parent.getData()
            // console.info(data);
            params['subject'] = data['subject']
            params['abstracts'] = data['abstracts']
          }
          params['sqlTableName'] = this.model.parent.tableName
          params['procDefId'] = this.procDefId
          params['formKey'] = this.model.parent.formKey || this.model.formKey
          params['id'] = this.id == undefined ? '' : this.id
          params['businessKey'] = params['id']
          params['currentUserUid'] = this.sessionUtil.getUserUid(this)
          params['currentUserName'] = this.sessionUtil.getUserName(this)
          params['currentUserId'] = this.sessionUtil.getUserId(this)
          params['ifSaveWorkflow'] = true
          params['operateType'] = 13
          params['procInstId'] = this.procInstId
          maskStr = '正在催办...'
        }
      }
      // 判断流程是否有上传附件
      let uploading = this.$refs['uploading']
      if (uploading) {
        if (uploading.length > 0) {
          uploading = uploading[0]
        }
        if (uploading) {
          let fileList = uploading.getFilesList()
          let deleteFilesList = uploading.getDeleteFilesList()
          if (fileList && fileList.length > 0) {
            if (params['filesList']) {
              params['filesList'] = params['filesList'].concat(fileList)
            } else {
              params['filesList'] = fileList
            }
          }
          if (deleteFilesList && deleteFilesList.length > 0) {
            if (params['deleteFilesList']) {
              params['deleteFilesList'] = params['deleteFilesList'].concat(deleteFilesList)
            } else {
              params['deleteFilesList'] = fileList
            }
          }
        }
      }

      // 保存前回调
      if (this.model.parent.beforeSaveData != undefined) {
        this.model.parent.beforeSaveData(type, params)
      }
      if (type == 3) {
        _this.util.confirm('你确定要撤销？', '提示', function () {
          _this.util.mask(maskStr)
          _this.saveData(type, params)
          if (this.model.parent.saveData != undefined) {
            this.model.parent.saveData(type, params)
          } else {
            _this.saveData(type, params)
          }
        })
      } else {
        _this.util.mask(maskStr)
        if (this.model.parent.saveData != undefined) {
          this.model.parent.saveData(type, params)
        } else {
          _this.saveData(type, params)
        }
      }
    },
    deleteProcInst (procInstId) {
      var _this = this
      _this.util.restDelete('/api_v1/wf/proc_insts', {procInstId: procInstId}, function (res) {
        if (res != undefined && res != null) {
          if(res.status == 200){
            _this.model.parent.isReadOnly = false
            if (_this.model.parent.updateStatus != undefined) {
              // 更新父节点状态
              _this.model.parent.updateStatus()
            }
            _this.isReadOnly = false
            _this.procInstId = null
            _this.procDefId = null
            _this.taskId = null
            _this.isApproval = false
            _this.isApply = false
            _this.isEndEvent = false
            // 重新加载流程
            _this.updateReadOnly(false)
            _this.initProcessMonitor()
            _this.initProcess()
          }else{

            _this.util.warn(res['errorMsg']);
          }

        }
        _this.util.unmask()
      })
    },
    saveData (type, params) {
      var _this = this
      // 说明是撤销
      if (type == 3) {
        this.deleteProcInst(_this.procInstId)
        return
      }
      _this.util.restPost('/api_v1/form/business', params, function (res) {
        if (res != undefined && res != null) {
          if (res.status == 200) {
            _this.util.successToast('成功')
            if (type == 18) {
              _this.isRevocation = false;
            }
            if (type == 4) {
            } else {
              _this.isReadOnly = true
              _this.ifBackFirst = false
              _this.isWorkflow = false
              _this.isApply = false
              _this.isApproval = false
              _this.isEndEvent = true
              _this.isCopy = false
              _this.ifShowProc = false
              _this.delegateTask = false
              _this.$store.state.operate = 'save'
              if (_this.model.parent.saveDataCallback != undefined) {
                _this.model.parent.saveDataCallback(type, params)
              } else if (_this.model.parent.submit != undefined) {
                _this.model.parent.submit(type)
              } else {
                // 保存完后回调
                // _this.$router.go(-1);
              }
            }
          } else {
            _this.util.failueToast('操作失败，' + res.errorMsg)
          }
        }
        _this.util.unmask()
      })
    },
    closeSelDialog () {
      this.dialogSelProcVisible = false
    },
    openPng () {
      // 打开流程图
      if (this.validUtil.isNotEmpty(this.procDefId)) {
        // this.pngVisible = true
        if (this.procInstId == null) {
          this.procInstId = ''
        }
        this.pngSrc = this.util.getBaseUrl() + '/api_v1/wf/png?procDefId=' + this.procDefId + '&procInstId=' + this.procInstId + '&access_token=' + this.sessionUtil.getAccessToken()
        // console.info(this.pngSrc);
        this.srcList = [this.pngSrc]

        // 创建对象
        var img = new Image();

        // 改变图片的src
        img.src = this.pngSrc;
        var _this = this
        // 判断是否有缓存
        if(img.complete){
          // 打印
          // alert('from:complete : width:'+img.width+',height:'+img.height);
          _this.imageWidth = img.width
          _this.pngVisible = true
        }else{
          // 加载完成执行
          img.onload = function(){
            // 打印
            // alert('from:onload : width:'+img.width+',height:'+img.height);
            _this.imageWidth = img.width
            _this.pngVisible = true
          };
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/wf/v2/mixin.js